<template>
  <div class="platform-edit-password">
    <div class="platform-edit-password__content">
      <h3 class="platform-edit-password__title">
        修改密码
      </h3>
      <div v-ds-loading="loading" class="platform-edit-password__form">
        <ds-form
          ref="ruleForm"
          :model="formData"
          :rules="rules"
          :hide-required-asterisk="true"
          status-icon
          label-width="120px">
          <ds-form-item label="账号：">
            {{ dataUser.userEmail }}
          </ds-form-item>
          <ds-form-item label="旧密码：" prop="oldPassword">
            <ds-input
              v-model="formData.oldPassword"
              type="password"
              autocomplete="off"
              style="width: 100%;"
            />
          </ds-form-item>
          <ds-form-item label="新密码：" prop="newPassword">
            <ds-input
              v-model="formData.newPassword"
              type="password"
              autocomplete="off"
              style="width: 100%;"
              @input="checkLevel(formData.newPassword)"
            />
          </ds-form-item>
          <ds-form-item label="安全程度：">
            <div class="platform-edit-password__safe">
              <span
                v-for="item in safeList.level"
                :key="item.id"
                :class="['platform-edit-password__safe-item', item.class]"
              />
              <i>{{ safeList.name }}</i>
            </div>
          </ds-form-item>
          <ds-form-item label="确认密码：" prop="checkPassword">
            <ds-input
              v-model="formData.checkPassword"
              type="password"
              autocomplete="off"
              style="width: 100%;"
            />
          </ds-form-item>
          <ds-form-item v-if="dataUser.userType === 0" label="LDAP验证码：" prop="code">
            <div class="platform-edit-password__flex">
              <ds-input v-model="formData.code" style="flex: 1;" />
              <span class="platform-edit-password__verified-text">
                <ds-button
                  v-if="!ldapVer.isShow"
                  type="primary"
                  @click="changeInternalPort"
                >
                  获取
                </ds-button>
                <span v-else class="e-button-small" size="small" type="primary">{{ ldapVer.time }} 秒</span>
              </span>
            </div>
          </ds-form-item>
          <ds-form-item>
            <ds-button
              class="platform-edit-password__button"
              type="primary"
              size="large"
              @click="submitForm('ruleForm')"
            >
              确认修改
            </ds-button>
          </ds-form-item>
        </ds-form>
      </div>
    </div>
  </div>
</template>

<script>
const PORT = {
  changePassword: '/user/changePassword',
  changeInternal: '/user/changeInternal',
  passwordUser: '/user/message'
}

function checkPass(pass) {
  let i = 0
  if (pass.match(/([a-z])+/)) {
    i++
  }
  if (pass.match(/([A-Z])+/)) {
    i++
  }
  if (pass.match(/([0-9])+/)) {
    i++
  }
  const pattern = new RegExp('[`~!@#$^&*()=|{}\':;\',\\[\\].<>《》/?~！@#￥……&*（）——|{}【】‘；：”“\'。，、？]')
  if (pattern.test(pass)) {
    i++
  }
  return i
}

const COUNTTIME = 60

export default {
  name: 'EditPassword',
  data() {
    var checkAge = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入旧密码'))
      } else {
        callback()
      }
    }
    const validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'))
      } else {
        callback()
      }
    }
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'))
      } else if (value !== this.formData.newPassword) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }
    return {
      formData: {
        oldPassword: '',
        newPassword: '',
        checkPassword: '',
        code: ''
      },
      ldapVer: {
        time: COUNTTIME,
        isShow: false,
        intervalTime: null
      },
      rules: {
        oldPassword: [{ validator: checkAge, trigger: 'blur' }],
        newPassword: [{ validator: validatePass, trigger: ['blur', 'change'] }],
        checkPassword: [{ validator: validatePass2, trigger: ['blur', 'change'] }],
        code: [
          { required: true, message: '请输入LDAP验证码', trigger: ['blur'] }
        ]
      },
      loading: false,
      // 获取密码输入的位数, 管理员可能企业用户中设置高级密码
      passwordLength: 6,
      passwordMaxLength: 20,
      safeList: {
        name: '',
        level: [{
          class: '',
          id: 1
        }, {
          class: '',
          id: 2
        }, {
          class: '',
          id: 3
        }]
      }
    }
  },
  computed: {
    dataUser() {
      return this.$store.state.userData
    }
  },
  mounted() {
    this.init()
    this.passwordUserPort()
  },
  methods: {
    init() {
      if (!this.dataUser.userId) {
        this.$router.push({ name: 'Login' })
        return false
      }
    },
    passwordUserPort() {
      this.loading = true
      this.$ucProxy({
        url: PORT.passwordUser,
        type: 'get'
      }).then(({ data }) => {
        this.loading = false
        const defaultPasswordLen = 6
        this.passwordLength = data.passwordLength || defaultPasswordLen
      })
    },
    changeInternalPort() {
      this.$ucProxy({
        url: PORT.changeInternal,
        type: 'post'
      }).then(res => {
        this.ldapVer.isShow = true
        this.countTime(COUNTTIME)
      })
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          const obj = {
            userId: this.dataUser.userId,
            oldPassword: this.formData.oldPassword,
            newPassword: this.formData.newPassword
          }
          if (this.dataUser.userType === 0) {
            obj.code = this.formData.code
          }
          this.changePasswordPort(obj)
        } else {
          return false
        }
      })
    },
    changePasswordPort(data) {
      this.$ucProxy({
        url: PORT.changePassword,
        type: 'post',
        data: data
      }).then(res => {
        if (res.success) {
          this.$message({
            message: '密码修改成功',
            type: 'success',
            duration: 1500
          })
          this.$router.push({ name: 'Home' })
        }
      })
    },
    checkLevel(pass) {
      const level = checkPass(pass)
      const passwordLevel1 = 2
      const passwordLevel2 = 3
      const passwordLevel3 = 4
      switch (level) {
        case passwordLevel1:
          this.safeList.name = '弱'
          this.safeList.level.map((item, index) => {
            if (index === 0) {
              item.class = 'account__red'
            } else {
              item.class = ''
            }
          })
          break
        case passwordLevel2:
          this.safeList.name = '中'
          this.safeList.level.map((item, index) => {
            if (index - passwordLevel1) {
              item.class = 'account__yellow'
            } else {
              item.class = ''
            }
          })
          break
        case passwordLevel3:
          this.safeList.name = '强'
          this.safeList.level.map((item, index) => {
            item.class = 'account__green'
          })
          break
        default:
          this.safeList = {
            name: '',
            level: [{
              class: '',
              id: 1
            }, {
              class: '',
              id: 2
            }, {
              class: '',
              id: 3
            }]
          }
          break
      }
    },
    // 验证码倒计时
    countTime(time) {
      const timeCountNum = 1000
      this.ldapVer.time = time
      const count = () => {
        if (this.ldapVer.time <= 0) {
          clearInterval(this.ldapVer.intervalTime)
          this.ldapVer.isShow = false
          return false
        }
        this.ldapVer.time--
      }
      this.ldapVer.intervalTime = setInterval(() => {
        count()
      }, timeCountNum)
    }
  }
}
</script>

<style lang="less" scoped>
.platform-edit-password {
  position: relative;
  height: 100%;
  overflow: auto;
  background: #fff;

  &__content {
    text-align: center;
    width: 420px;
    padding: 80px 0;
    margin: 0 auto;
  }

  &__title {
    color: #222222;
    font-weight: bolder;
    font-size: 16px;
  }

  &__form {
    text-align: left;
    padding-top: 20px;
  }

  &__safe {
    height: 30px;
    width: 100%;
    display: flex;
    align-items: center;

    i {
      font-style: normal;
      padding: 0 10px;
    }

    span {
      display: inline-block;
      height: 8px;
      margin-right: 2px;
      background-color: #E2E2E2;
    }

    span.account__red {
      background-color: #EC2A1D;
    }

    span.account__yellow {
      background-color: #F4B847;
    }

    span.account__green {
      background-color: #29A34E;
    }

    &-item {
      flex: 1;
    }
  }

  &__flex {
    width: 100%;
    display: flex;
    align-items: center;
    gap: 12px;
  }

  &__verified-text {
    display: inline-block;
    text-align: center;
    font-size: 12px;
  }

  &__button {
    width: 100%;
    margin-top: 20px;
  }
}
</style>
